// based on rc-time-picker 3.7.3
export { default } from './TimePicker';


//////////////////
// WEBPACK FOOTER
// ./~/ant-design-vue/es/vc-time-picker/index.js
// module id = 893
// module chunks = 0